import {Paper, Tooltip, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";


const ImageButton = styled(ButtonBase)(({ theme }) => ({
      position: 'relative',
      height: 150,
      [theme.breakpoints.down('sm')]: {
        width: '100% !important', // Overrides inline-style
        height: 100,
      },
      '&:hover, &.Mui-focusVisible': {
        zIndex: 1,
        '& .MuiImageBackdrop-root': {
          opacity: 0.15,
        },
        '& .MuiImageMarked-root': {
          opacity: 0,
        },
        '& .MuiTypography-root': {
          border: '4px solid currentColor',
        },
      },
}));

const ImageSrc = styled('span')({
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundSize: '100% 100%',
      backgroundPosition: 'center 40%',
});

const Image = styled('span')(({ theme }) => ({
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.common.white,
}));

const ImageBackdrop = styled('span')(({ theme }) => ({
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: theme.palette.common.black,
      opacity: 0.4,
      transition: theme.transitions.create('opacity'),
}));

const ImageMarked = styled('span')(({ theme }) => ({
      height: 3,
      width: 18,
      backgroundColor: theme.palette.common.white,
      position: 'absolute',
      bottom: -2,
      left: 'calc(50% - 9px)',
      transition: theme.transitions.create('opacity'),
}));

export function CardItemComponent({thingsData, handlingClickItem=null}){
    return(
        <Paper elevation={12}>
            <Tooltip title={thingsData.tool}>
                <ImageButton  focusRipple style={{width: '100%'}} onClick={()=>handlingClickItem(thingsData)} >
                    <ImageSrc style={{backgroundImage: `url(${thingsData.img})`}} />
                    <ImageBackdrop className="MuiImageBackdrop-root" />
                    <Image>
                        <Typography>
                            {thingsData.name}
                            <ImageMarked className="MuiImageMarked-root" />
                        </Typography>
                    </Image>
                </ImageButton>
            </Tooltip>
        </Paper>
    );
}